export default __webpack_public_path__ + "6012833d481773a341008b7d762fac17.png";